import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Header from "./components/Header";
import About from "./components/About";
import Contact from "./components/Contact";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import ScrollToTop from "./components/ScrollToTop";
import ArticlesList from "./components/ArticlesList";
import ArticleDetail from "./components/ArticleDetail";

import "./App.css";

const REACT_APP_GTM_ID = process.env.REACT_APP_GTM_ID ; // Remplace par ton vrai ID Google Analytics

const App = () => {
  // Vérifie si l'utilisateur a déjà accepté ou refusé les cookies
  const [cookiesAccepted, setCookiesAccepted] = useState(() => {
    const storedValue = localStorage.getItem("cookiesAccepted");
    return storedValue === "true" ? true : storedValue === "false" ? false : null;
  });

  useEffect(() => {
   // console.log("✅ Valeur actuelle de cookiesAccepted:", cookiesAccepted);
    
    if (cookiesAccepted) {
     // console.log("✅ Consentement aux cookies donné, ajout du script Google Analytics...");

      // Ajout du script Google Analytics après consentement
      const script1 = document.createElement("script");
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${REACT_APP_GTM_ID}`;
      document.head.appendChild(script1);

      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${REACT_APP_GTM_ID}');
      `;
      document.head.appendChild(script2);
    }
  }, [cookiesAccepted]);

  // Fonction pour accepter les cookies
  const handleAcceptCookies = () => {
   // console.log("✅ L'utilisateur a accepté les cookies.");
    localStorage.setItem("cookiesAccepted", "true");
    setCookiesAccepted(true);
  };

  // Fonction pour refuser les cookies
  const handleRejectCookies = () => {
    //console.log("❌ L'utilisateur a refusé les cookies.");
    localStorage.setItem("cookiesAccepted", "false");
    setCookiesAccepted(false);
  };

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/articles" element={<ArticlesList />} />
        <Route path="/article/:id" element={<ArticleDetail />} />
      </Routes>
      <Footer />

      {/* Bannière de consentement aux cookies */}
      {cookiesAccepted === null && (
        <div className="cookie-banner">
          <p>This site uses cookies to improve your experience.</p>
          <button onClick={handleAcceptCookies}>Accept</button>
          <button onClick={handleRejectCookies}>Refuse</button>
        </div>
      )}
    </Router>
  );
};

export default App;
